module.exports = __webpack_public_path__ + "static/media/micro.88365110.jpg";